import React from "react";

import { KeyName } from "../../keyName";
import TestIds from "../../testIds";
import { ItemDescription, ItemTitle, StyledProductTypeItem } from "./PurchaseWizard.styles";

interface IProps {
    id?: string;
    title: string;
    description?: string;
    isCentered?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
    isWithoutDescription?: boolean;
    // used in dialog as standalone informative item,
    // without any additional actions
    isStandaloneUse?: boolean;
    onClick?: (id: string) => void;
}

export default class PurchaseWizardTile extends React.PureComponent<IProps> {
    handleClick = (): void => {
        this.props.onClick?.(this.props.id);
    };

    handleKeyDown = (event: React.KeyboardEvent): void => {
        if (event.key === KeyName.Enter) {
            this.handleClick();
        }
    };

    render() {
        return (
            <StyledProductTypeItem $isSelected={this.props.isSelected}
                                   $isDisabled={this.props.isDisabled}
                                   tabIndex={0}
                                   $isCentered={this.props.isCentered}
                                   $isStandaloneUse={this.props.isStandaloneUse}
                                   onClick={this.handleClick}
                                   onKeyDown={this.handleKeyDown}
                                   data-testid={TestIds.ProductTypeItem}>
                <ItemTitle data-testid={TestIds.Title}
                           $isStandaloneUse={this.props.isStandaloneUse}>
                    {this.props.title}
                </ItemTitle>
                {!this.props.isWithoutDescription &&
                    <ItemDescription data-testid={TestIds.Subtitle}>{this.props.description}</ItemDescription>}
                {this.props.children}
            </StyledProductTypeItem>
        );
    }
}

export type { IProps as IProductTypeItemProps };